import { IRequesterInfo } from '../../../../../base/models/proxyModels'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { SavePreOrderRequest, SavePreOrderResponse } from '../models/models'
export class SendDealerApprovalApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({ url: 'admin/preOrder/sendApproval', requesterInfo })
  }

  public async send(request: number[]): Promise<any> {
    return await this.postAsync<any>(request)
  }
}
